import { CoreButton } from '@components'
import ArrowRightIcon from '@images/icons/arrow-right-white-small.svg?react'

import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import { type ReactNode, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

type WorkflowStepProps = {
  icon: ReactNode
  id: string
  index: number
  title: string
  description: string
  actionLink: string
  actionText: string
  isActionNeeded: (id: string) => boolean
  openCreateReportModal: () => void
}

const WorkflowStep = (props: WorkflowStepProps) => {
  const { icon, id, index, title, description, actionLink, actionText, isActionNeeded, openCreateReportModal } = props

  const needsAction = useMemo(() => isActionNeeded(id), [id, isActionNeeded])
  const departmentsNeedAction = useMemo(() => isActionNeeded('SET_UP_DEPARTMENTS'), [isActionNeeded])

  const history = useHistory()

  const handleActionClick = useCallback(() => {
    history.push(actionLink)
  }, [history, actionLink])

  return (
    <div className='step-wrapper'>
      <div className='step'>
        <div className={cn('step-icon', { completed: !needsAction })}>{icon}</div>
        <div className='step-content'>
          <div className='title'>
            {index}. {title}
          </div>
          <div className='description'>{description}</div>
        </div>
        <div className='action'>
          {needsAction ? (
            <CoreButton
              fullWidth
              size='normal'
              text={actionText}
              RightIcon={<ArrowRightIcon />}
              onClick={handleActionClick}
              disabled={id === 'SET_UP_APPROVAL_RULES' && departmentsNeedAction}
            />
          ) : (
            <div className='action-completed'>
              <span className='action-completed-text'>
                {tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW.ACTION_COMPLETED', 'Completed')}
              </span>
            </div>
          )}
        </div>
      </div>

      {id === 'SET_UP_DEPARTMENTS' && needsAction && (
        <div className='sub-description'>
          <span className='sub-description-text-1'>
            {tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW.NO_DEPARTMENTS', '-> No departments? No problem!')}
          </span>
          <span className='sub-description-text-2'>
            {tr(
              'FRONTEND.EXPENSES.EXPENSE_WORKFLOW.INVITE_YOUR_TEAM_DESCRIPTION_2',
              'All approvers can approve, and admins give the final go.'
            )}
            <CoreButton
              variation='secondary'
              size='small'
              text={tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW.CREATE_REPORT', 'Create your first report!')}
              onClick={openCreateReportModal}
            />
          </span>
        </div>
      )}
    </div>
  )
}

export default WorkflowStep
